import React from "react";
import { PageHeader } from "@ant-design/pro-layout";
import { Layout, Row, Col, theme, Tag } from "antd";
import { Platform } from "../../types/platform";
import { MediationCrawlerCard } from "./MediationCrawlerCard";
import { AbstractCrawlerCard } from "./AbstractCrawlerCard";
import { SpmCrawlerCard } from "./SpmCrawlerCard";

const { Content } = Layout;
const { useToken } = theme;

export const CrawlerPage = () => {
  const { token } = useToken();

  const isDarkTheme = token.colorBgBase === "#000";

  return (
    <Layout>
      <Content>
        <PageHeader title="Crawler" />
        <Row gutter={[16, 16]}>
          <Col span={12}>
            <MediationCrawlerCard
              title="Appodeal"
              allowVersioning
              mediation="appodeal"
              platform={Platform.IOS}
              repos={["appodeal/CocoaPods"]}
            >
              <p style={{ color: isDarkTheme ? "#9E9E9E" : "#616161" }}>
                Type exact version of <b>Core Appodeal iOS SDK</b> or leave
                above text field empty to crawl the latest release
              </p>
            </MediationCrawlerCard>
          </Col>
          <Col span={12}>
            <MediationCrawlerCard
              title="Appodeal"
              allowVersioning
              mediation="appodeal"
              platform={Platform.ANDROID}
              repos={[
                "artifactory.appodeal.com/appodeal",
                "artifactory.appodeal.com/appodeal-beta-public",
              ]}
              defaultRepo="artifactory.appodeal.com/appodeal"
            >
              <p style={{ color: isDarkTheme ? "#9E9E9E" : "#616161" }}>
                Type exact version of <b>Full Appodeal Android SDK</b> or leave
                above text field empty to crawl the latest release
              </p>
            </MediationCrawlerCard>
          </Col>
        </Row>
        <Row gutter={[16, 16]}>
          <Col span={12}>
            <MediationCrawlerCard
              allowVersioning
              title={<>BidMachine <Tag color="orange">Deprecated</Tag></>}
              mediation="bidmachine"
              platform={Platform.IOS}
              repos={["bidmachine/CocoaPods-Specs"]}
            >
              <p style={{ color: isDarkTheme ? "#9E9E9E" : "#616161" }}>
                Type <b>3 components of BidMachine iOS SDK version</b> or leave
                above text field empty to crawl the latest release
              </p>
            </MediationCrawlerCard>
          </Col>
          <Col span={12}>
            <MediationCrawlerCard
              allowVersioning
              title="BidMachine"
              mediation="bidmachine"
              platform={Platform.ANDROID}
              repos={["artifactory.bidmachine.io/bidmachine"]}
              defaultRepo="artifactory.bidmachine.io/bidmachine"
            >
              <p style={{ color: isDarkTheme ? "#9E9E9E" : "#616161" }}>
                Type exact version <b>BidMachine Android SDK</b> (min 3.6.0) or
                leave above text field empty to crawl the latest release
              </p>
            </MediationCrawlerCard>
          </Col>
        </Row>
        <Row gutter={[16, 16]}>
          <Col span={12}>
            <MediationCrawlerCard
              allowVersioning
              title="Bidon"
              mediation="bidon"
              platform={Platform.IOS}
              repos={["bidon-io/CocoaPods-Specs"]}
            >
              <p style={{ color: isDarkTheme ? "#9E9E9E" : "#616161" }}>
                Type exact version <b>Bidon iOS SDK</b> or leave above text
                field empty to crawl the latest release
              </p>
            </MediationCrawlerCard>
          </Col>
          <Col span={12}>
            <MediationCrawlerCard
              allowVersioning
              title="Bidon"
              mediation="bidon"
              platform={Platform.ANDROID}
              repos={["artifactory.appodeal.com/bidon"]}
              defaultRepo="artifactory.appodeal.com/bidon"
            >
              <p style={{ color: isDarkTheme ? "#9E9E9E" : "#616161" }}>
                Type exact version <b>Bidon Android SDK</b> or leave above text
                field empty to crawl the latest release
              </p>
            </MediationCrawlerCard>
          </Col>
        </Row>
        <Row gutter={[16, 16]}>
          <Col span={12}>
            <MediationCrawlerCard
              title="AppLovin MAX"
              mediation="max"
              platform={Platform.IOS}
            />
          </Col>
          <Col span={12}>
            <MediationCrawlerCard
              title="AppLovin MAX"
              mediation="max"
              platform={Platform.ANDROID}
            />
          </Col>
        </Row>
        <Row gutter={[16, 16]}>
          <Col span={12}>
            <MediationCrawlerCard
              allowVersioning
              title="LevelPlay"
              mediation="levelplay"
              platform={Platform.IOS}
            />
          </Col>

          <Col span={12}>
            <MediationCrawlerCard
              allowVersioning
              title="LevelPlay"
              mediation="levelplay"
              platform={Platform.ANDROID}
            />
          </Col>
        </Row>
        <Row gutter={[16, 16]}>
          <Col span={12}>
            <SpmCrawlerCard />
          </Col>
        </Row>
        <Row gutter={[16, 16]}>
          <Col span={12}>
            <AbstractCrawlerCard platform={Platform.IOS} />
          </Col>
          <Col span={12}>
            <AbstractCrawlerCard platform={Platform.ANDROID} />
          </Col>
        </Row>
      </Content>
    </Layout>
  );
};
